import { render, staticRenderFns } from "./business-opportunities.vue?vue&type=template&id=cc9d0e40&scoped=true"
import script from "./business-opportunities.vue?vue&type=script&lang=js"
export * from "./business-opportunities.vue?vue&type=script&lang=js"
import style0 from "./business-opportunities.vue?vue&type=style&index=0&id=cc9d0e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9d0e40",
  null
  
)

export default component.exports